const initials = "fetchSlides/";
export const UPDATE_SLIDER_PRODUCTS = `${initials}UPDATE_SLIDER_PRODUCTS`;
